import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import {
    addDays,
    differenceInHours,
    secondsToMilliseconds,
    startOfDay,
} from 'date-fns';

import { selectEpgParams } from 'store/epg/selectors';

import { CONFIG } from 'screens/Epg/utils/config';

export default function useEpgConfig() {
    const { start: epgDataStartTime } = useSelector(selectEpgParams);

    const selectedDate = secondsToMilliseconds(epgDataStartTime);

    const hoursCount = useMemo(() => {
        const startOfDaySelectedDate = startOfDay(selectedDate);
        const startOfDayNextDate = startOfDay(addDays(selectedDate, 1));
        return Math.abs(
            differenceInHours(startOfDaySelectedDate, startOfDayNextDate),
        );
    }, [selectedDate]);

    return useMemo(() => {
        return {
            ...CONFIG,
            hoursCount,
        };
    }, [hoursCount]);
}
